<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['展商活动', title + '展商活动']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
              ref="form"
              class="add-form"
              :rules="rules"
              :model="form"
              label-width="140px"
            >
              <el-form-item label="活动标题：" prop="title">
                <el-input v-model.trim="form.title"></el-input>
              </el-form-item>
              <!--              <el-form-item label="活动类型：" prop="activityType">-->
              <!--                <el-select v-model="form.activityType" placeholder="请选择" style="width: 100%" clearable>-->
              <!--                  <el-option-->
              <!--                      v-for="item in activityTypeList"-->
              <!--                      :key="item.value"-->
              <!--                      :label="item.label"-->
              <!--                      :value="item.value"-->
              <!--                  >-->
              <!--                  </el-option>-->
              <!--                </el-select>-->
              <!--              </el-form-item>-->
              <el-form-item label="列表封面图：" prop="cover">
                <ListUpload @success="getListCover" :img="listCoverList" :limit="1" />
              </el-form-item>
              <el-form-item label="宣传图：" prop="detailsImgUrl">
                <DetailUpload
                  @success="getDetailsImgUrl"
                  :img="detailsImgUrlList"
                />
              </el-form-item>
              <el-form-item label="开始时间：" prop="startDate">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.startDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="
                    '请选择时间 ' + startDate + '到' + endDate + ' 之间'
                  "
                  @change="selectStartDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间：" prop="endDate">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.endDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="
                    '请选择时间 ' + startDate + '到' + endDate + ' 之间'
                  "
                  @change="selectEndDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="简介：" prop="introduction">
                <el-input
                  v-model.trim="form.introduction"
                  type="textarea"
                  :rows="3"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址类型：" prop="addressType">
                <el-radio-group
                  v-model="form.addressType"
                  @change="changeAddressType"
                >
                  <el-radio label="1">会议室</el-radio>
                  <el-radio label="2">展馆</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="地址：" prop="address" v-if="form.addressType">
                <el-input v-model.trim="form.address"></el-input>
              </el-form-item>
              <el-form-item label="详情：" prop="details">
                <editor ref="editor" height="300" @setHtml="setHtml" />
              </el-form-item>
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{ form.reason + '，请确认修改完成后点击提交审核' }}</p>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../../components/navHeader.vue'
import ListUpload from '../../../components/listUpload'
import DetailUpload from '../../../components/detailUpload'
import editor from '../../../components/editor.vue'

export default {
  name: 'detail',
  data () {
    return {
      loading: true,
      id: '',
      companyId: sessionStorage.getItem('companyId'),
      title: '添加',
      type: 'add',
      form: {
        type: '2',
        activityType: '',
        title: '',
        cover: '',
        startDate: '',
        endDate: '',
        address: '',
        addressType: '',
        introduction: '',
        detailsImgUrl: '',
        details: ''
      },
      address: '',
      startDate: '',
      endDate: '',
      startDateOptions: {
        // let start = new Date(this.startDate).getTime()
        disabledDate: (time) => {
          return false
        }
      },
      rules: {
        title: {
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        },
        cover: {
          required: true,
          message: '请上传列表封面图',
          trigger: 'blur'
        },
        detailsImgUrl: {
          required: true,
          message: '请上传宣传图',
          trigger: 'blur'
        },
        startDate: {
          required: true,
          message: '请选择开始时间',
          trigger: 'blur'
        },
        endDate: {
          required: true,
          message: '请选择结束时间',
          trigger: 'blur'
        },
        introduction: {
          required: true,
          message: '请输入简介',
          trigger: 'blur'
        },
        addressType: {
          required: true,
          message: '请选择地址类型',
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        },
        details: {
          required: true,
          message: '请输入详情',
          trigger: 'blur'
        }
      },
      activityTypeList: [
        {
          label: '日化',
          value: '1'
        },
        {
          label: '专业',
          value: '2'
        },
        {
          label: '工厂',
          value: '3'
        },
        {
          label: '服务商',
          value: '4'
        }
      ],
      listCoverList: [],
      detailsImgUrlList: []
    }
  },
  components: {
    navHeader,
    ListUpload,
    DetailUpload,
    editor
  },
  mounted () {
    this.getTime()
    this.getAddress()
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getDetail(this.id)
    } else {
      this.id = ''
      this.$refs.editor.initEditor()
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/exhibitionActivity/getById', { id })
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            this.listCoverList = res.data.data.cover
              ? res.data.data.cover.split(',')
              : []
            this.detailsImgUrlList = res.data.data.detailsImgUrl
              ? res.data.data.detailsImgUrl.split(',')
              : []
            this.$refs.editor.initEditor(this.form.details)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
        })
    },
    getAddress () {
      this.$http
        .post('/company/getById', { id: this.companyId })
        .then((res) => {
          this.address = res.data.data.boothNumber
        })
    },
    async getTime () {
      let { data: res } = await this.$http.post('/cbeBaseInfo/getInfo')
      this.startDate = res.data.startDate
      this.endDate = res.data.endDate
    },
    getListCover (list) {
      this.form.cover = list.join(',')
    },
    getDetailsImgUrl (list) {
      this.form.detailsImgUrl = list.join(',')
    },
    back () {
      this.$router.back()
    },
    save () {
      this.$refs.form.validate((val) => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          let url = ''
          if (this.type === 'add') {
            url = '/exhibitionActivity/add'
          } else {
            url = '/exhibitionActivity/update'
          }
          this.$http
            .post(url, params)
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success(res.data.msg)
                this.$router.back()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((e) => {
              console.log(e)
            })
        }
      })
    },
    changeAddressType (val) {
      if (val === '1') {
        this.form.address = ''
      } else {
        this.form.address = this.address
      }
    },
    setHtml (html) {
      this.form.details = html
    },
    selectStartDate (val) {
      if (val < this.startDate || val > this.endDate) this.form.startDate = ''
    },
    selectEndDate (val) {
      if (val < this.startDate || val > this.endDate) this.form.endDate = ''
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/exhibitionManage/businessmanActivity/detail.vue